export class ValidVideo {
  sdSrc: boolean;
  hdSrc: boolean;

  constructor(sdSrc: boolean, hdSrc: boolean){
    this.sdSrc = sdSrc
    this.hdSrc = hdSrc
  }

  hasVideo() {
    return this.sdSrc || this.hdSrc;
  }
}

export class VideoSource {
  keyName: "sd" | "hd";
  url: string;
  default?: boolean;

  constructor(keyName: "sd" | "hd", url: string, defaultVideo?: boolean){
    this.keyName = keyName
    this.url = url
    this.default = defaultVideo
  }
}
